import { fromJS } from 'immutable';
import * as constants from './constants';

const defaultState = fromJS({
	userName: '',
	isUserName: false,
	errUserName: '',
	userTel: '',
	isUserTel: false,
	errUserTel: '',
	userPass: '',
	isUserPass: false,
	errUserPass: '',
	userRPass: '',
	isUserRPass: false,
	errUserRPass: '',
	phoneYzm: '',
	isErrorPhoneYzm: false,
	errPhoneYzm: '',
	phonePyzm: '',
	isErrorPhonePyzm: false,
	errPhonePyzm: '',
	captcha: '',
	sendYzmText: '发送验证码',
	isSendYzmText: false,
	countdown: 120,
	sending: false,
	getSign: '',
	isManuBtnClick: false,
})

export default ( state = defaultState, action ) => {
	switch(action.type) {
		case constants.TOGGLE_USERNAME_ERR:
			return state.merge({
				'isUserName': action.value,
				'errUserName': action.text
			});
		case constants.TOGGLE_USERTEL_ERR:
			return state.merge({
				'isUserTel': action.value,
				'errUserTel': action.text
			});
		case constants.TOGGLE_PASS_ERR:
			return state.merge({
				'isUserPass': action.value,
				'errUserPass': action.text
			});
		case constants.TOGGLE_RPASS_ERR:
			return state.merge({
				'isUserRPass': action.value,
				'errUserRPass': action.text
			});
		case constants.TOGGLE_YZM_ERR:
			return state.merge({
				'isErrorPhoneYzm': action.value,
				'errPhoneYzm': action.text
			});
		case constants.TOGGLE_PYZM_ERR:
			return state.merge({
				'isErrorPhonePyzm': action.value,
				'errPhonePyzm': action.text
			});
		case constants.HANDLE_USERNAME_CHANGE:
			return state.set('userName', action.value);
		case constants.HANDLE_USERTEL_CHANGE:
			return state.set('userTel', action.value);
		case constants.HANDLE_PASS_CHANGE:
			return state.set('userPass', action.value);
		case constants.HANDLE_RPASS_CHANGE:
			return state.set('userRPass', action.value);
		case constants.HANDLE_YZM_CHANGE:
			return state.set('phoneYzm', action.value);
		case constants.HANDLE_PYZM_CHANGE:
			return state.set('phonePyzm', action.value);
		case constants.TOGGLE_SENDING:
			return state.set('sending', action.value);
		case constants.SET_YZM_SIGN:
			return state.set('getSign', action.value);
		case constants.SET_YZM_BTN_TEXT:
			return state.merge({
				'isSendYzmText': action.value,
				'sendYzmText': action.text
			});
		case constants.SET_COUNT_DOWN_NUM:
			return state.set('countdown', action.value);
		case constants.RESET_FORM:
			return state.merge({
				'userTel': '',
				'isUserTel': false,
				'errUserTel': '',
				'userPass': '',
				'isUserPass': false,
				'errUserPass': '',
				'userRPass': '',
				'isUserRPass': false,
				'errUserRPass': '',
				'phoneYzm': '',
				'isErrorPhoneYzm': false,
				'errPhoneYzm': '',
				'phonePyzm': '',
				'isErrorPhonePyzm': false,
				'errPhonePyzm': '',
			});
		case constants.SET_CAPTCHA:
			return state.set('captcha', action.url);
		case constants.MANU_BTN_CLICK:
			return state.set('isManuBtnClick', action.value);
		default: 
			return state;
	}
}


